import { render, staticRenderFns } from "./inputPolicy.vue?vue&type=template&id=43e4d6c9&"
import script from "./inputPolicy.vue?vue&type=script&lang=js&"
export * from "./inputPolicy.vue?vue&type=script&lang=js&"
import style0 from "./inputPolicy.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./inputPolicy.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports